import React, { Fragment, useState } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { getDateFormat } from "../../components/common";

// --------------------------------------------------------------------
//
// --------------------------------------------------------------------
const WeekButton = ({ children, id, onClick, disabled }) => {
  return (
    <Button className="m-1" onClick={onClick} value={id} disabled={disabled}>
      {children}
    </Button>
  );
};

// --------------------------------------------------------------------
//
// --------------------------------------------------------------------
const WeekStateForm = ({ week, state, handleState }) => {
  return (
    <Fragment>
      <Row>
        <Col>
          수업 : {week ? week.course.courseName : undefined} {" - "}
          {week ? week.course.classRoom : undefined} <br />
          주차 : {week ? week.week-11 : undefined} <br />
          시간 : {week ? week.course.classHour : undefined}
        </Col>
        <Col>
          <Form.Group controlId="dsuni-week-state">
            <Form.Label>상태</Form.Label>
            <Form.Select value={state ?? "none"} onChange={handleState}>
              <option value="none">none</option>
              <option value="open">open</option>
              <option value="close">close</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
    </Fragment>
  );
};

// --------------------------------------------------------------------
//
// --------------------------------------------------------------------
const WeekAuthForm = ({ auth, handleAuth }) => {
  return (
    <Form className="mb-3">
      <Form.Group controlId="dsuni-week-authcode">
        <Row>
          <Col>
            <Form.Label>인증 코드</Form.Label>
            <Form.Control
              placeholder="0000"
              name="code"
              value={auth.code}
              maxLength={4}
              onChange={handleAuth}
            />
          </Col>
          <Col>
            <Form.Label>시작일</Form.Label>
            <Form.Control
              type="date"
              name="beginDate"
              value={getDateFormat(auth.beginDate)}
              onChange={handleAuth}
            />
          </Col>
          <Col>
            <Form.Label>완료일</Form.Label>
            <Form.Control
              type="date"
              name="endDate"
              value={getDateFormat(auth.endDate)}
              onChange={handleAuth}
            />
          </Col>
        </Row>
      </Form.Group>
    </Form>
  );
};

// --------------------------------------------------------------------
//
// --------------------------------------------------------------------
const WeekTeamForm = ({
  weekNumber,
  team,
  selectedTeamName,
  handleSelectTeam,
  handleRemoveQuest,
  handleRemoveStudent,
}) => {
  return (
    <Row className="mb-3">
      <Col md={1}>
        <Button
          variant={selectedTeamName === team.name ? "primary" : "secondary"}
          value={team.name}
          onClick={handleSelectTeam}
        >
          {team.name}
        </Button>
      </Col>
      <Col>
        {team.quests.map((it, index) => {
          return (
            <WeekButton
              key={index}
              id={it._id}
              onClick={handleRemoveQuest}
              disabled={
                Number(weekNumber) === 12
                  ? true
                  : selectedTeamName === team.name
                  ? false
                  : true
              }
            >
              {it.buildingName}
            </WeekButton>
          );
        })}
      </Col>
      <Col>
        {team.students.map((it, index) => {
          return (
            <WeekButton
              key={index}
              id={it._id}
              onClick={handleRemoveStudent}
              disabled={selectedTeamName === team.name ? false : true}
            >
              {it.displayName}
            </WeekButton>
          );
        })}
      </Col>
    </Row>
  );
};

// --------------------------------------------------------------------
//
// --------------------------------------------------------------------
/**
 * 주에 속한 팀들에서 사용 중인 퀘스트들과 학생들
 *
 * @param {number} weekNumber 숫자
 * @param {object} teams 팀들
 * @param {string} selectedTeamName 선택되어진 팀 이름
 * @param {function} handleSelectTeam 팀 선택에 대한 호출 함수
 * @param {function} handleRemoveQuest 팀에서 퀘스트 제거에 대한 호출 함수
 * @param {function} handleRemoveStudent 팀에서 학생을 제거에 대한 호출 함수
 * @returns
 */
const WeekUsedForm = ({
  weekNumber,
  teams,
  selectedTeamName,
  handleSelectTeam,
  handleRemoveQuest,
  handleRemoveStudent,
}) => {
  return (
    <Fragment>
      {teams ? (
        teams.map((it, index) => {
          return (
            <div key={index}>
              <WeekTeamForm
                weekNumber={weekNumber}
                team={it}
                selectedTeamName={selectedTeamName}
                handleSelectTeam={handleSelectTeam}
                handleRemoveQuest={handleRemoveQuest}
                handleRemoveStudent={handleRemoveStudent}
              />
            </div>
          );
        })
      ) : (
        <div>사용 중인 팀이 없습니다.</div>
      )}
    </Fragment>
  );
};

// --------------------------------------------------------------------
//
// --------------------------------------------------------------------
/**
 * 팀에 속하지 않는 콘덴츠
 * @param {*} param0
 * @returns
 */
const WeekUnusedForm = ({
  weekNumber,
  unusedQuests,
  unusedStudents,
  handleAddQuest,
  handleAddStudent,
}) => {
  let unusedQuestsWeekButtons = undefined;
  if (weekNumber === 12) {
    unusedQuestsWeekButtons = (
      <div>{weekNumber-11}주차는 팀별 퀘스트들이 고정입니다.</div>
    );
  } else {
    unusedQuestsWeekButtons =
      unusedQuests && unusedQuests.length > 0 ? (
        unusedQuests.map((it, index) => {
          return (
            <WeekButton
              key={index}
              id={it._id}
              onClick={handleAddQuest}
              disabled={weekNumber === 12}
            >
              {it.buildingName}
            </WeekButton>
          );
        })
      ) : (
        <div>팀에서 사용하지 않은 퀘스트는 0개입니다.</div>
      );
  }

  const unusedStudentsWeekButtons =
    unusedStudents && unusedStudents.length > 0 ? (
      unusedStudents.map((it, index) => {
        return (
          <WeekButton key={index} id={it._id} onClick={handleAddStudent}>
            {it.displayName}
          </WeekButton>
        );
      })
    ) : (
      <div>어떠한 팀에서도 속하지 않은 학생은 0명입니다.</div>
    );

  return (
    <Fragment>
      <Row className="mb-3">
        <Col md={1}>대기</Col>
        <Col>{unusedQuestsWeekButtons}</Col>
        <Col>{unusedStudentsWeekButtons}</Col>
      </Row>
    </Fragment>
  );
};

// --------------------------------------------------------------------
//
// --------------------------------------------------------------------
export const WeekDetailForm = ({
  week,
  state,
  handleState,

  auth,
  handleAuth,

  selectedTeamName,
  handleSelectTeam,
  handleRemoveQuest,
  handleRemoveStudent,

  unusedQuests,
  unusedStudents,
  handleAddQuest,
  handleAddStudent,

  handleAddTeam,
  handleRemoveTeam,

  btnSaveDirty,
  handleSave,
  handleClose,
}) => {
  if (!week) {
    return null;
  }

  const weekNumber = Number(week.week);

  const HeaderTable = (
    <Row className="mb-3">
      <Col md={1}>팀명</Col>
      <Col>퀘스트들</Col>
      <Col>학생들</Col>
    </Row>
  );

  const AddOrRemoveTeamForm =
    weekNumber === 13 ? (
      <Fragment>
        <Button
          className="mt-3 me-3"
          variant="warning"
          onClick={handleRemoveTeam}
        >
          팀 삭제하기
        </Button>
        <Button className="mt-3" variant="info" onClick={handleAddTeam}>
          팀 추가하기
        </Button>
      </Fragment>
    ) : null;

  return (
    <Fragment>
      <hr />
      <WeekStateForm week={week} state={state} handleState={handleState} />
      <hr />
      <WeekAuthForm auth={auth} handleAuth={handleAuth} />
      <hr />
      {HeaderTable}
      <hr />
      <WeekUsedForm
        weekNumber={weekNumber}
        teams={week ? week.teams : undefined}
        selectedTeamName={selectedTeamName}
        handleSelectTeam={handleSelectTeam}
        handleRemoveQuest={handleRemoveQuest}
        handleRemoveStudent={handleRemoveStudent}
      />
      {AddOrRemoveTeamForm}
      <hr />
      <WeekUnusedForm
        weekNumber={weekNumber}
        unusedQuests={unusedQuests}
        unusedStudents={unusedStudents}
        handleAddQuest={handleAddQuest}
        handleAddStudent={handleAddStudent}
      />
      <hr />
      <Button onClick={handleSave} disabled={!btnSaveDirty}>
        저장
      </Button>
      <Button onClick={handleClose} className="ms-3" variant="info">
        확인
      </Button>
    </Fragment>
  );
};
